import React, { useState, useEffect } from "react";

import SearchableSelect from "util/component/SearchableSelect";

import { BORDER_COLOR } from "../Functions";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const UserAuthSelected = (props, ref) => {
    const [AuthSelect, SetAuthSelect] = useState([]);

    const { selecteduser, removeSelectedUser, onChange, authList } = props;

    const HandleSelectedUser = (rowData) => {
        removeSelectedUser(rowData);
    }

    const HandleAuthSelect = (selected) => {
        if (!AuthSelect?.find((f) => f.value === selected.value)) {
            SetAuthSelect((OLD) => [...OLD, selected]);
        }
    };
    return (
        <div className={"userAuthSelected-wrapper"}>
            <div className={`userAuthSelected-userlist`}>
                <table
                    className={
                        "bpl-table-default small fixed compact-row userAuthSelected-userlist-table"
                    }
                    style={{ fontSize: "0.8rem" }}
                >
                    <colgroup>
                        <col width="100px" />
                        <col />
                        <col width="30px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>User ID</th>
                            <th>User Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {selecteduser?.map((rowData, index) => {
                            return (
                                <tr key={"selectedUserAuthTable" + index}>
                                    <td title={rowData.userId}>{rowData.userId}</td>
                                    <td title={rowData.userNm}>{rowData.userNm}</td>
                                    <td className={"del-btn text-center"} onClick={() => HandleSelectedUser(rowData)}>
                                        <FontAwesomeIcon icon={faClose} />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className={`userAuthSelected-selector`}>
                <div>
                    <SearchableSelect
                        options={authList}
                        onChange={HandleAuthSelect}
                        value={null}
                        search
                        border={"ON"}
                        placeholder="Choose Authorization"
                        placeholderTextAlign="center"
                        arrow
                    />
                </div>
                <div className={`userAuthSelected-selector-btn-list`}>
                    {AuthSelect?.map((selected, index) => {
                        return (
                            <button
                                key={"selectedAuthBtn" + index}
                                style={{
                                    borderColor: BORDER_COLOR[selected.value],
                                    color: BORDER_COLOR[selected.value],
                                }}
                                onClick={() => {
                                    SetAuthSelect((OLD) => {
                                        const newOld = [...OLD]
                                        const findIdx = newOld.findIndex(
                                            (f) => f.value === selected.value
                                        );
                                        newOld.splice(findIdx, 1)
                                        return newOld;
                                    });
                                }}
                            >
                                {selected.label}
                            </button>
                        );
                    })}
                </div>
            </div>
            <div className={`userAuthSelected-actor`}>
                <div>
                    <button disabled={AuthSelect?.length === 0 || selecteduser?.length === 0} className={`bpl-btn success`} onClick={() => onChange("Insert", AuthSelect)}>Add</button>
                </div>
                <div>
                    <button disabled={AuthSelect?.length === 0 || selecteduser?.length === 0} className={`bpl-btn danger`} onClick={() => onChange("Delete", AuthSelect)}>Remove</button>
                </div>
            </div>
        </div>
    );
};

export default UserAuthSelected;
